// Mock stories data for the Caribbean LGBTQ+ travel platform
const mockStories = [
  {
    id: 1,
    title: "Finding Acceptance in Puerto Rico",
    author: {
      id: 1,
      name: "Maria Sanchez",
      avatar: "https://randomuser.me/api/portraits/women/65.jpg"
    },
    date: "2025-05-20",
    location: "San Juan, Puerto Rico",
    content: "Growing up as a trans woman in Puerto Rico wasn't always easy, but the vibrant LGBTQ+ community in San Juan has become my home. I love sharing the hidden gems of my city with fellow queer travelers. From the colorful streets of Old San Juan to the welcoming beaches of Ocean Park, there's a place for everyone here.",
    images: [
      "https://www.discoverpuertorico.com/sites/default/files/2019-01/Old%20San%20Juan%20Colorful%20Streets.jpg",
      "https://www.discoverpuertorico.com/sites/default/files/2019-01/SanJuanBeach.jpg"
    ],
    tags: ["trans", "local", "puerto rico", "acceptance"],
    likes: 45,
    comments: 12,
    visibility: "community"
  },
  {
    id: 2,
    title: "Island Hopping as a Non-Binary Traveler",
    author: {
      id: 3,
      name: "Sophie Williams",
      avatar: "https://randomuser.me/api/portraits/women/33.jpg"
    },
    date: "2025-04-15",
    location: "Bonaire, Curaçao, Aruba",
    content: "The ABC islands (Aruba, Bonaire, Curaçao) offer a surprisingly welcoming experience for non-binary travelers like myself. While I was initially concerned about how I'd be received, I found that the Dutch influence has created more accepting spaces, especially in tourist areas. Bonaire's diving community was particularly inclusive!",
    images: [
      "https://www.tourismbonaire.com/includes/images/gallery/diving-bonaire.jpg"
    ],
    tags: ["non-binary", "island hopping", "diving", "abc islands"],
    likes: 38,
    comments: 8,
    visibility: "public"
  },
  {
    id: 3,
    title: "Navigating Trinidad's Carnival as a Gay Man",
    author: {
      id: 4,
      name: "Alex Rivera",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    date: "2025-03-10",
    location: "Port of Spain, Trinidad",
    content: "Trinidad's Carnival is a riot of color, music, and freedom - but it can be complicated for LGBTQ+ travelers. As a local gay man, I've learned how to navigate the celebration safely while still having an incredible time. The key is knowing which events are queer-friendly and connecting with local guides.",
    images: [
      "https://www.travelandleisure.com/thmb/Q5wGYK1JJK9-_QVLOHM8JRGSBiA=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/trinidad-carnival-TRINICARNI0217-b2a0a89832134e4f9c67c8fa41de80b7.jpg"
    ],
    tags: ["carnival", "gay", "local knowledge", "trinidad"],
    likes: 52,
    comments: 15,
    visibility: "community"
  },
  {
    id: 4,
    title: "Digital Nomad Life in Aruba",
    author: {
      id: 2,
      name: "David Chen",
      avatar: "https://randomuser.me/api/portraits/men/22.jpg"
    },
    date: "2025-06-01",
    location: "Oranjestad, Aruba",
    content: "As a gay digital nomad, finding LGBTQ+ friendly workspaces can be challenging. Aruba has surprised me with its welcoming atmosphere and great infrastructure for remote work. The internet is reliable, there are several co-working spaces, and the beaches provide the perfect backdrop for after-work relaxation.",
    images: [
      "https://www.aruba.com/sites/default/files/styles/hero_image_desktop_1920x744/public/content/header/Palm_Beach_Aruba_sunset_1920x744.jpg"
    ],
    tags: ["digital nomad", "gay", "aruba", "remote work"],
    likes: 29,
    comments: 7,
    visibility: "public"
  },
  {
    id: 5,
    title: "Sailing the Caribbean as a Queer Couple",
    author: {
      id: 10,
      name: "James Walker",
      avatar: "https://randomuser.me/api/portraits/men/78.jpg"
    },
    date: "2025-05-05",
    location: "US Virgin Islands, British Virgin Islands",
    content: "My partner and I spent three weeks sailing through the Virgin Islands, and it was the adventure of a lifetime. We found most islands to be welcoming, though we were careful about public displays of affection in certain areas. The sailing community itself was incredibly accepting and we made lifelong friends.",
    images: [
      "https://www.travellady.com/wp-content/uploads/British-Virgin-Islands-Sailing.jpeg"
    ],
    tags: ["sailing", "couple", "virgin islands", "adventure"],
    likes: 41,
    comments: 9,
    visibility: "community"
  }
];

export default mockStories;
